import { getCookie } from 'utils';
import { API } from '../../utils';
import { ILogInParams } from './types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { AUTHORIZATION, C300, DISPATCHER } = GW_SERVICES_PREFIXES;
/* Авторизация */
export const GatewayLogIn = (data: ILogInParams) =>
  API.gatewayPost(`/${AUTHORIZATION}/auth/login/`, data);

/* Выход из системы */
export const GatewayLogOut = () => {
  const csrftoken = getCookie('csrftoken');

  return API.gatewayPost(
    `/${AUTHORIZATION}/auth/logout/`,
    undefined,
    csrftoken ? { 'X-CSRFToken': csrftoken } : undefined
  );
};

/* Данные пользователя */
export const GetUserInfo = () => API.get(`/${C300}/user/current/`);

/* Получение токена для сквозной авторизации */
export const PostAuthThroughKey = (params: { key: string }) => {
  return API.gatewayPost(
    `/${AUTHORIZATION}/auth/exchange_redirect_token/`,
    params
  );
};

/* Восстановление пароля */
export const ResetPassword = (login: string) =>
  API.gatewayPost(`/${AUTHORIZATION}/account/reset_password/`, {
    username: login,
  });

// Получение  прав доступа пользователя, данные из permissions используется так же для рендера табов меню
export const GetPermissions = () => {
  const csrftoken = getCookie('csrftoken');

  return API.gatewayPost(
    `/${AUTHORIZATION}/auth/verify/`,
    undefined,
    csrftoken ? { 'X-CSRFToken': csrftoken } : undefined
  );
};

export const GetWorkerAccounts = () => {
  const csrftoken = getCookie('csrftoken');

  return API.get(
    `/${AUTHORIZATION}/auth/get_worker_users/`,
    undefined,
    undefined,
    csrftoken ? { 'X-CSRFToken': csrftoken } : undefined
  );
};

export const ChangeUserForWorker = (user_id: string) => {
  const csrftoken = getCookie('csrftoken');

  return API.gatewayPost(
    `/${AUTHORIZATION}/auth/change_user_for_worker/`,
    { user_id },
    csrftoken ? { 'X-CSRFToken': csrftoken } : undefined
  );
};
